// 「登録意思がある」と判断できたことの記録・購読を担う。
// 現状の唯一の利用者はGENIEEのLINE登録促進モーダルの出し分け（utils/genieeLinePromo）だが、
// このモジュール自体は用途を知らない。判定の定義をここ1箇所に閉じるのが目的。
//
// 記録は sessionStorage に置く。1ページ内のstep遷移だけでなく、リロード・ブラウザバック・
// bfcache復帰をまたいでも「一度ステップに進んだ人」を覚えておく必要があるため。
// 次回訪問まで残す必要はないので localStorage は使わない。

// 現状は「フォームのステップを1つ以上進めた」のみ。
// 転職意欲ポップで high を選んだ人を含めるかは、まず本対応の効果を見てから判断する（DEV-3300の議論）。
export type IntentReason = 'step_advanced'

const STORAGE_KEY = 'fl_registration_intent'
const VALID_REASONS: string[] = ['step_advanced']

type IntentListener = (reason: IntentReason) => void

const listeners = new Set<IntentListener>()

// プライベートブラウズ等で sessionStorage が例外を投げる環境でも
// 当該ページ内では機能するよう、メモリ側にも保持する
let memoizedReason: IntentReason | null = null

// sessionStorage の読み出しは最初の1回だけにする。
// hasIntent() はスクロール中に何度も呼ばれるため、毎回同期I/Oを走らせるとジャンクの原因になる
let isHydrated = false

export const getIntent = (): IntentReason | null => {
    if (memoizedReason) return memoizedReason
    if (isHydrated) return null

    isHydrated = true
    try {
        const stored = sessionStorage.getItem(STORAGE_KEY)
        if (stored && VALID_REASONS.includes(stored)) {
            memoizedReason = stored as IntentReason
        }
    } catch (e) {
        // 参照できない環境ではメモリ側のみで判定する
    }

    return memoizedReason
}

export const hasIntent = (): boolean => getIntent() !== null

// 最初に記録された理由だけを保持する（2回目以降は無視）。
// 購読側は「一度呼ばれたら恒久的に抑止」を前提にしてよい。
export const markIntent = (reason: IntentReason): void => {
    if (hasIntent()) return

    memoizedReason = reason

    try {
        sessionStorage.setItem(STORAGE_KEY, reason)
    } catch (e) {
        // 保存できなくてもメモリ側で当該ページ内は機能する
    }

    listeners.forEach((listener) => listener(reason))
}

export const subscribeIntent = (listener: IntentListener): (() => void) => {
    listeners.add(listener)
    return () => {
        listeners.delete(listener)
    }
}
